import sparqljs from 'sparqljs';
import rdf from '@zazuko/env/web.js';
import { DuplicatePatternRemover } from '@hydrofoil/sparql-processor/DuplicatePatternRemover.js';
import { PrefixExtractor } from '@hydrofoil/sparql-processor/PrefixExtractor.js';
import { shapeToPatterns } from './shapeToPatterns.js';
import { UnionRepeatedPatternsRemover } from './optimizer/UnionRepeatedPatternsRemover.js';
const generator = new sparqljs.Generator();
const defaultOptimizers = () => [
    new DuplicatePatternRemover(rdf),
    new UnionRepeatedPatternsRemover(rdf),
    new PrefixExtractor(rdf),
];
export function constructQuery(shape, { optimizers = [], ...options } = {}) {
    const patterns = shapeToPatterns(shape, options);
    return optimizeAndStringify({
        type: 'query',
        queryType: 'CONSTRUCT',
        where: patterns.whereClause,
        prefixes: {},
        template: patterns.constructClause,
    }, optimizers);
}
export function deleteQuery(shape, { optimizers = [], ...options } = {}) {
    const patterns = shapeToPatterns(shape, options);
    let graph;
    if (options.graph) {
        if (typeof options.graph === 'string') {
            graph = rdf.namedNode(options.graph);
        }
        else {
            graph = options.graph;
        }
    }
    return optimizeAndStringify({
        type: 'update',
        updates: [{
                updateType: 'insertdelete',
                insert: [],
                delete: [{
                        type: 'bgp',
                        triples: patterns.constructClause,
                    }],
                where: patterns.whereClause,
                graph,
            }],
        prefixes: {},
    }, optimizers);
}
function optimizeAndStringify(query, optimizers) {
    return generator.stringify([...optimizers, ...defaultOptimizers()]
        .reduce((query, optimizer) => optimizer.process(query), query));
}
